import { useMemo } from "react";
import { useSelector } from "react-redux";

import { canAdminModule } from "./Permissions";

/** Unwrap `{ success, data, message }` from an axios admin_portal/v2 response. */
export const extractAdminPortalData = (response) => {
  const envelope = response?.data;
  if (!envelope || typeof envelope !== "object") return null;
  return envelope.data ?? null;
};

export const extractAdminPortalList = (response) => {
  const data = extractAdminPortalData(response);
  return Array.isArray(data) ? data : [];
};

export const extractAdminPortalMessage = (response) =>
  response?.data?.message ?? "";

/** Admin module flags (`Employees`, `Roles Management`, `Manage Clients`, …).
 * Delegates to the central `canAdminModule` so route guards (non-React) and
 * this hook (React) share one implementation. */
export const useAdminModulePermission = (moduleName) => {
  const permissions = useSelector((state) => state.auth.permission);

  return useMemo(
    () => ({
      canView: canAdminModule(moduleName, "can_view"),
      canAdd: canAdminModule(moduleName, "can_add"),
      canEdit: canAdminModule(moduleName, "can_edit"),
      canDelete: canAdminModule(moduleName, "can_delete"),
    }),
    [permissions, moduleName],
  );
};
